"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('setup.css', function () {
    this.append = function (visuals, type, deferred) {
        namespace_1.default.debug.showInfo('Appending ' + type + 'css');
        var defArr = [];
        Object.keys(visuals).forEach(function (index) {
            var filePath = namespace_1.default.params.paths[type].css;
            var tPath = filePath + '/' + type + '.' + visuals[index] + '.css?cb=' + namespace_1.default.params.cachebreaker;
            var tCss = document.createElement('link');
            tCss.rel = 'stylesheet';
            tCss.type = 'text/css';
            tCss.id = tPath;
            tCss.href = tPath;
            tCss.onload = function () {
                deferred.resolve();
            };
            tCss.onerror = function () {
                console.error("An error occurred loading the stylesheet!");
                deferred.reject();
            };
            document.getElementsByTagName('HEAD')[0].appendChild(tCss);
        });
    };
});
